"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.visitas_weight = void 0;
var percentage_1 = require("./percentage");
var sum_1 = require("./sum");
/**
 * Cria pesos para cada imóvel de cada visita passada como input, retorna uma lista de [imoveis, weights]
 * @example
 * const v = [{ imoveis_visitados: ['S3CO9BIGiLkdOgHy4xqb'], time_fim_visita: 1611262779971, time_inicio_visita: 1611262726257 }]
 * const vw = visitas_weight(v)
 *
 * vw === [['S3CO9BIGiLkdOgHy4xqb', 1]]
 *
 * sum(vw.map(([id, w]) => w)) // 1 ou 0.99999999999999 por razoes de inconsistencia de float
 * @param visitas
 */
var visitas_weight = function (visitas) {
    var id_weight = [];
    var t_diffs = visitas.map(function (visita) { return visita.time_fim_visita - visita.time_inicio_visita; });
    var t_total = sum_1.default(t_diffs);
    for (var _i = 0, visitas_1 = visitas; _i < visitas_1.length; _i++) {
        var visita = visitas_1[_i];
        var diff = visita.time_fim_visita - visita.time_inicio_visita;
        var w = percentage_1.XisWhatPercentOfY(diff, t_total) / 100;
        for (var _a = 0, _b = visita.imoveis_visitados; _a < _b.length; _a++) {
            var imovel = _b[_a];
            id_weight.push([imovel, w / visita.imoveis_visitados.length]);
        }
    }
    return id_weight;
};
exports.visitas_weight = visitas_weight;
